import OTPInput from "react-otp-input";
import "./OTP.scss";
import ErrorText from "../ErrorText/ErrorText";
const OTP = ({
  options,
  className,
  label,
  value,
  onChange,
  numInputs,
  placeholder,
  name,
  formik,
  ...rest
}) => {

  return (
    <>
      <div className={`OTP ${className || ""}`}>
        {label && <label>{label}</label>}
        <div className="OTP_inner">
          <OTPInput
            name={name}
            value={value}
            onChange={onChange}
            // numInputs={6 || numInputs}
            numInputs={numInputs || 6}

            placeholder={placeholder}
            // renderSeparator={<span>-</span>}
            renderInput={(props) => <input {...props} />}
            {...rest}
          />
        </div>
        {formik?.touched[name] && formik?.errors[name] && (
          <ErrorText>{formik?.errors[name]}</ErrorText>
        )}
      </div>
    </>
  );
};

export default OTP;
